import React from 'react';

const SelectDropDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5.482"
      height="4.047"
      viewBox="0 0 5.482 4.047"
    >
      <path
        id="Shape"
        d="M3.99,2.849.2,5.459A.131.131,0,0,1,0,5.352V.131A.131.131,0,0,1,.2.023L3.99,2.634a.131.131,0,0,1,0,.215Z"
        transform="translate(5.482) rotate(90)"
      />
    </svg>
  );
};

export default SelectDropDown;
